
import { Base } from '../base-component';
import './tab-item.component.scss';

export class TabItem extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/tab-item/tab-item.component.ts